// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export interface ExternallyAccessibleNostosV1 {
  id: string;
  content: any;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface ExternallyAccessibleNostosV1Connection {
  elements: Array<ExternallyAccessibleNostosV1> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface ExternallyAccessibleNostosV1GetAllPropertiesQuery {
  ExternallyAccessibleNostosV1: {
    getAllProperties: ExternallyAccessibleNostosV1Connection | null;
  } | null;
}

export interface ExternallyAccessibleNostosV1GetAllPropertiesQueryVariables {
  job_name: string;
  keys: string;
  overrideVersion?: string | null;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
      ? PartialConstruction<T[TKey]>
      : T[TKey];
};

export class ExternallyAccessibleNostosV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'externallyAccessibleNostos.v1' as const;

  declare id: string;

  declare content: any;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<ExternallyAccessibleNostosV1>) {
    super(params);
  }
}
